import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useT } from '@/i18n'
import { api } from '@/lib/api'
import { Skeleton } from '@/components/States'

// Dashboard uchun ixcham SMS-xulosa (Infobip balans + jami yuborilgan + top davlatlar).
// A24.05 to'liq ekranga havola. Backend: GET /admin/sms/stats. Izolyatsiyalangan komponent —
// asosiy dashboardга bitta qator bilan qo'shiladi ("hammasi dashboardда ham bo'lsin").
interface SmsStatsLite {
  balance?: number
  currency?: string
  total_sent?: number
  by_country?: { country: string; count: number }[]
}

export function SmsSummaryCard() {
  const t = useT()
  const [d, setD] = useState<SmsStatsLite | null>(null)
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    const ac = new AbortController()
    let alive = true
    api
      .get<SmsStatsLite>('/admin/sms/stats', { signal: ac.signal })
      .then((r) => {
        if (alive) setD(r)
      })
      .catch(() => {})
      .finally(() => {
        if (alive) setLoading(false)
      })
    return () => {
      alive = false
      ac.abort()
    }
  }, [])
  const bal = d?.balance !== undefined ? `${d.balance.toFixed(2)} ${d.currency ?? ''}`.trim() : '—'
  return (
    <div className="rounded-lg border border-border-default bg-surface-2 p-3">
      <div className="mb-2 flex items-center justify-between">
        <div className="text-sm font-medium text-secondary">{t.sms.title}</div>
        <Link to="/settings/sms-providers" className="text-xs text-accent hover:underline">
          {t.sms.recent} →
        </Link>
      </div>
      {loading ? (
        <Skeleton className="h-16 w-full" />
      ) : (
        <div className="grid grid-cols-2 gap-2">
          <div className="rounded-md border border-border-subtle bg-surface-1 p-2">
            <div className="text-xs text-tertiary">{t.sms.balance}</div>
            <div className="mt-0.5 font-mono text-xl tabular text-accent">{bal}</div>
          </div>
          <div className="rounded-md border border-border-subtle bg-surface-1 p-2">
            <div className="text-xs text-tertiary">{t.sms.totalSent}</div>
            <div className="mt-0.5 font-mono text-xl tabular text-primary">
              {(d?.total_sent ?? 0).toLocaleString()}
            </div>
          </div>
          {d?.by_country?.length ? (
            <div className="col-span-2 flex flex-wrap gap-1.5 pt-1">
              {d.by_country.slice(0, 5).map((c) => (
                <span
                  key={c.country}
                  className="rounded-full border border-border-subtle px-2 py-0.5 text-xs text-secondary"
                >
                  {c.country}: <span className="tabular text-primary">{c.count.toLocaleString()}</span>
                </span>
              ))}
            </div>
          ) : null}
        </div>
      )}
    </div>
  )
}
